import * as catalogos from 'app/idiomas/i18n/perfiles/catalogos/en';
export const locale = {
  lang: 'en',
  data: {
    'RAWDATA': {
      'CATALOGOS': {
        'broker': catalogos.institutos,
      },
      'TITULO': 'Consult Raw Data',
      'SUBTITULO': 'Consult the information of the Raw Data of the surveys generated on the platform in a specific period',
      'NOFILE': 'Not generated',
      'FILTER': 'Filter by Company or Survey Token',
      'DOWNLOADFILE': 'Download file',
      'CAMPOS': {
        'anio': 'Year',
        'broker': 'Broker',
        'brokerCountry': 'Broker country',
        'anioRanking': 'Year ranking',
      },
      'COLUMNAS': {
        'nombre': 'Company',
        'producto': 'Product type',
        'surveytoken': 'Survey Token',
        'fecha': 'Date',
        'acciones': 'Raw data',
        'tiporawdata': 'Raw Data type'
      },
      'RESULTADOS': {
        'CARGANDO': 'Loading search results',
        'TITULO': 'Results',
        'ENCONTRADAS': 'Total surveys found',
        'DESCARGAR': 'Download information in Excel format',
        'SINRESULTADOS': 'No surveys created with the specified parameters were found'
      }
    }
  }
};
